import { experimental_extendTheme as extendTheme } from "@mui/material/styles";
import { enUS } from "@mui/material/locale";
import { frFR } from "@mui/material/locale";
import { esES } from "@mui/material/locale";
import {
  Experimental_CssVarsProvider as CssVarsProvider,
} from '@mui/material/styles';
import * as React from "react";
import { useLocationConfiguration } from "./LocationConfiguration";

function getLocale() {
  const htmlLangAttribute = document.documentElement.lang;
  switch (htmlLangAttribute) {
    case "en_US":
      return enUS;
    case "es_US":
      return esES;
    case "fr_US":
      return frFR;
    default:
      // TODO we need to add support for user added languages
      return enUS;
  }
}
interface LS2ThemeProviderProps extends React.PropsWithChildren {
  isKids: boolean
}

export const LS2ThemeProvider = ({
  children,
  isKids,
}: LS2ThemeProviderProps) => {

  const { locationConfiguration } = useLocationConfiguration();
  const { primaryColor, secondaryColor } = locationConfiguration.pacSettings.displaySettings;

  const LS2PACTheme = React.useMemo(() => {
    return extendTheme(
      {
        colorSchemes: {
          light: {
            palette: {
              primary: {
                main: primaryColor,
              },
              secondary: {
                main: secondaryColor,
              },
              contrastThreshold: 4.5,
            },
          },
        },
        typography: {
          button: {
            textTransform: "capitalize",
          },
        },
      },
      getLocale()
    );
  }, [primaryColor, secondaryColor]) 

  const theme = isKids? LS2KidsTheme : LS2PACTheme;
  return ( 
      <CssVarsProvider theme={theme}>
        {children}
      </CssVarsProvider> 
    )
}

export const PreviewThemeProvider = ({
  children,
}: LS2ThemeProviderProps) => {

  const { locationConfiguration } = useLocationConfiguration();
  const { primaryColor, secondaryColor } = locationConfiguration.pacSettings.displaySettings;
  console.log("PreviewThemeProvider theme updated: %s %s", primaryColor, secondaryColor)

  const LS2PacTheme = React.useMemo(() => {
    return extendTheme(
      {
        cssVarPrefix: 'md-demo',
        colorSchemes: {
          light: {
            palette: {
              primary: {
                main: primaryColor,
              },
              secondary: {
                main: secondaryColor,
              },
              contrastThreshold: 4.5,
            },
          },
        },
        typography: {
          button: {
            textTransform: "capitalize",
          },
        },
      },
      getLocale()
    );
  }, [primaryColor, secondaryColor])

  return ( 
      <CssVarsProvider theme={LS2PacTheme}>
        {children}
      </CssVarsProvider> 
    )
}

export const LS2KidsTheme = extendTheme(
  {
    colorSchemes: {
      light: {
        palette: {
          contrastThreshold: 4.5,
          primary: {
            main: "#0071bc",
          },
        },
      },
    },

    typography: {
      button: {
        textTransform: "none",
        fontFamily: "taffyregular",
        fontSize: "1.5rem",
      },
    },
  },
  getLocale()
);
